import { createTheme } from "@mui/material/styles";

const RTL_LANGS = new Set(["ar"]);

export const buildAppTheme = (language: string) => {
  const normalized = (language || "fr").split("-")[0];
  const direction = RTL_LANGS.has(normalized) ? "rtl" : "ltr";

  return createTheme({
    direction,
    typography: {
      fontFamily: "var(--font-family-ui)",
      allVariants: {
        fontFamily: "var(--font-family-ui)",
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          "*, *::before, *::after": {
            fontFamily: "var(--font-family-ui)",
          },
        },
      },
    },
  });
};
